(function () {
  if (window.__pcpRebuyCartGroupInit) return;
  window.__pcpRebuyCartGroupInit = true;

  const GROUP_PROP = '_Customizer Group';
  const TYPE_PROP = '_Customizer Type';
  const DESIGN_PROP = 'Customized Design';
  const FINAL_SALE_AGREEMENT_PROPERTY = 'Final Sale Agreement';
  const HIDDEN_CLASS = 'pcp-rebuy-line-item--hidden';
  const GROUP_CLASS = 'pcp-rebuy-customizer-group';
  const MAX_GROUP_ATTEMPTS = 12;
  const ENRICHMENT_WAIT_MS = 450;
  const LINE_KEY_ATTRS = ['data-line-key', 'data-item-key', 'data-cart-item-key', 'data-key', 'data-id'];
  const ITEMS_CONTAINER_SELECTORS = [
    '[data-smartcart-items]',
    '.rebuy-cart__flyout-items',
    '#rebuy-cart .rebuy-cart__flyout-items',
    '[data-smartcart-component="cart_items"] ul',
    '[data-component-type="cart_items"] ul',
    '.smart-cart__cart-items ul',
    '.smart-cart [class*="cart-items"] ul',
  ];
  const TITLE_SELECTOR =
    '.rebuy-cart__flyout-item-product-title, [class*="item-product-title"], [class*="product-title"]';
  const VARIANT_SELECTOR =
    '.rebuy-cart__flyout-item-variant-title, [class*="item-variant-title"], [class*="variant-title"]';
  const CART_EVENTS = [
    'rebuy:cart.change',
    'rebuy:cart.add',
    'rebuy:cart.enriched',
    'rebuy:smartcart.show',
    'rebuy:smartcart.ready',
    'rebuy:smartcart.line-item-removed',
    'rebuy:smartcart.hide',
  ];

  let lastAppliedHash = '';
  let groupingTimer = null;
  let observer = null;
  let isApplying = false;
  let groupingPending = false;
  let awaitingEnrichment = false;
  let enrichmentTimer = null;
  let lastGroupedKeys = new Set();

  function retryDelay(attempt) {
    if (attempt < 3) return 40;
    if (attempt < 7) return 80;
    return 120;
  }

  function getRebuyCart() {
    return (
      (window.Rebuy && window.Rebuy.Cart && window.Rebuy.Cart.cart) ||
      (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.getCart === 'function'
        ? window.Rebuy.Cart.getCart()
        : null)
    );
  }

  function countGroupedItems(groups) {
    return groups.reduce(function (total, group) {
      return total + group.items.length;
    }, 0);
  }

  function countMappedItems(groups, elementMap) {
    let count = 0;
    for (const group of groups) {
      for (const item of group.items) {
        if (elementMap[item.key]) count += 1;
      }
    }
    return count;
  }

  function retryGrouping(attempt, callback) {
    if (attempt < MAX_GROUP_ATTEMPTS) {
      window.setTimeout(callback, retryDelay(attempt));
    }
  }

  function readKeyFromElement(el) {
    for (const attr of LINE_KEY_ATTRS) {
      const value = el.getAttribute(attr);
      if (value) return String(value).trim();
    }
    return '';
  }

  function clearEnrichmentWait(runGrouping) {
    awaitingEnrichment = false;
    if (enrichmentTimer) {
      window.clearTimeout(enrichmentTimer);
      enrichmentTimer = null;
    }
    if (runGrouping) scheduleGrouping(true);
  }

  function startEnrichmentWait() {
    awaitingEnrichment = true;
    lastAppliedHash = '';
    if (enrichmentTimer) window.clearTimeout(enrichmentTimer);
    enrichmentTimer = window.setTimeout(function () {
      enrichmentTimer = null;
      clearEnrichmentWait(true);
    }, ENRICHMENT_WAIT_MS);
  }

  function getLineItemKeyFromElement(el) {
    if (!el || el.nodeType !== 1) return '';

    const directKey = readKeyFromElement(el);
    if (directKey) return directKey;

    const keyedChild = el.querySelector(
      '[data-line-key], [data-item-key], [data-cart-item-key], [data-key]'
    );
    return keyedChild ? readKeyFromElement(keyedChild) : '';
  }

  function elementMatchesInstance(el, instanceId) {
    if (!instanceId || !el) return false;
    return String(el.textContent || '').indexOf(instanceId) !== -1;
  }

  function groupedItemsFullyHidden(groups, elementMap) {
    for (const group of groups) {
      for (const item of group.items) {
        const el = elementMap[item.key];
        if (el && !el.classList.contains(HIDDEN_CLASS)) return false;
      }
    }
    return true;
  }

  function getCartItems() {
    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.items === 'function') {
      try {
        const smartItems = window.Rebuy.SmartCart.items();
        if (Array.isArray(smartItems) && smartItems.length) return smartItems;
      } catch (error) {
        /* fall through */
      }
    }

    const cart = getRebuyCart();
    if (!cart || !Array.isArray(cart.items)) return [];
    return cart.items.filter(function (item) {
      return !isHiddenRebuyItem(item);
    });
  }

  function isHiddenRebuyItem(item) {
    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.isHiddenItem === 'function') {
      try {
        return window.Rebuy.SmartCart.isHiddenItem(item);
      } catch (error) {
        /* fall through */
      }
    }

    let tags = item.tags || (item.product && item.product.tags) || [];
    if (typeof tags === 'string') tags = tags.split(',');
    return tags.some(function (tag) {
      return String(tag).trim().toLowerCase() === 'smart-cart-hidden';
    });
  }

  function getProp(item, key) {
    if (!item || !item.properties) return '';
    const value = item.properties[key];
    if (value == null) return '';
    return String(value).trim();
  }

  function formatMoney(cents) {
    if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.formatMoney === 'function') {
      return window.Rebuy.Cart.formatMoney(cents);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function decodeHtmlEntities(value) {
    return String(value || '')
      .replace(/&quot;/g, '"')
      .replace(/&#34;/g, '"')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getEngraveFontClass(font) {
    const key = String(font || '').trim().toLowerCase();
    if (key === 'cursive') return 'pcp-engrave-font--cursive';
    if (key === 'sans serif') return 'pcp-engrave-font--sans-serif';
    if (key === 'serif') return 'pcp-engrave-font--serif';
    if (key === 'script') return 'pcp-engrave-font--script';
    if (key === 'block') return 'pcp-engrave-font--block';
    return '';
  }

  function getItemsContainer() {
    for (const selector of ITEMS_CONTAINER_SELECTORS) {
      const match = document.querySelector(selector);
      if (match) return match;
    }

    const cartRoot =
      document.querySelector('#rebuy-cart') ||
      document.querySelector('.rebuy-cart') ||
      document.querySelector('[class*="smart-cart"]');

    if (cartRoot) {
      return (
        cartRoot.querySelector('[data-smartcart-items]') ||
        cartRoot.querySelector('.rebuy-cart__flyout-items') ||
        cartRoot.querySelector('ul')
      );
    }

    return null;
  }

  function isLineItemElement(element) {
    if (!element || element.nodeType !== 1) return false;
    if (element.classList.contains(GROUP_CLASS)) return false;

    if (element.classList.contains('rebuy-cart__flyout-item')) return true;

    const className = element.className || '';
    return /cart.*item|line-item|flyout-item/i.test(String(className));
  }

  function getLineElements(container) {
    const direct = Array.prototype.slice.call(
      container.querySelectorAll(':scope > .rebuy-cart__flyout-item:not(.' + GROUP_CLASS + ')')
    );
    if (direct.length) return direct;

    return Array.prototype.slice.call(container.children).filter(isLineItemElement);
  }

  function buildGroups(items) {
    const groups = [];
    const groupMap = {};
    const groupOrder = [];

    items.forEach(function (item) {
      const groupId = getProp(item, GROUP_PROP);
      if (!groupId) return;

      if (!groupMap[groupId]) {
        groupMap[groupId] = {
          id: groupId,
          items: [],
          keys: [],
          total: 0,
          design: '',
          title: '',
          chains: [],
          charms: [],
          others: [],
          finalSaleAgreement: '',
          returnUrl: '',
        };
        groupOrder.push(groupId);
      }

      const group = groupMap[groupId];
      group.items.push(item);
      group.keys.push(item.key);
      group.total += item.final_line_price || item.line_price || 0;

      const design = getProp(item, DESIGN_PROP);
      if (!group.design && design) group.design = design;

      const type = getProp(item, TYPE_PROP);
      if (!group.title && type === 'chain') {
        group.title = item.product_title || item.title || '';
      }

      if (!group.finalSaleAgreement) {
        group.finalSaleAgreement = getProp(item, FINAL_SALE_AGREEMENT_PROPERTY);
      }

      if (!group.returnUrl) {
        group.returnUrl = getProp(item, '_Customizer Return URL');
      }

      if (type === 'chain') group.chains.push(item);
      else if (type === 'charm') group.charms.push(item);
      else group.others.push(item);
    });

    groupOrder.forEach(function (groupId) {
      const group = groupMap[groupId];
      if (!group.title && group.items.length) {
        group.title = group.items[0].product_title || group.items[0].title || 'Custom Jewelry';
      }
      groups.push(group);
    });

    return groups;
  }

  function buildGroupHash(items, groups) {
    return items
      .map(function (item) {
        return item.key + ':' + getProp(item, GROUP_PROP);
      })
      .join('|') + '::' + groups.length;
  }

  function renderVariantLine(item, type) {
    const variantTitle = decodeHtmlEntities(
      getProp(item, '_Variant Label') || String(item.variant_title || '').trim()
    );
    if (!variantTitle || variantTitle === 'Default Title') return '';
    const prefix = type === 'chain' ? 'Size: ' : '';
    return '<p class="review-product-variant">' + prefix + escapeHtml(variantTitle) + '</p>';
  }

  function renderFinalSaleAgreement(value) {
    if (!value) return '';

    return (
      '<div class="review-product-engraving customizer-cart-group__final-sale-agreement">' +
      '<span class="review-product-engraving-label">' +
      escapeHtml(FINAL_SALE_AGREEMENT_PROPERTY) +
      ': </span>' +
      '<span class="review-product-engraving-text">' +
      escapeHtml(value) +
      '</span>' +
      '</div>'
    );
  }

  function renderEngraving(item) {
    const engraving = getProp(item, 'Engraving');
    if (!engraving) return '';

    const font = getProp(item, 'Engraving Font');
    const fontClass = getEngraveFontClass(font);
    const fontSuffix = font ? ' (' + escapeHtml(font) + ')' : '';

    return (
      '<div class="review-product-engraving">' +
      '<span class="review-product-engraving-label">Engraving: </span>' +
      '<span class="review-product-engraving-text' +
      (fontClass ? ' ' + fontClass : '') +
      '">' +
      escapeHtml(engraving) +
      '</span>' +
      (font ? '<span class="review-product-engraving-font">' + fontSuffix + '</span>' : '') +
      '</div>'
    );
  }

  function getItemQuantity(item) {
    const qty = parseInt(item.quantity, 10);
    return qty > 0 ? qty : 1;
  }

  function renderLineItem(item) {
    const type = getProp(item, TYPE_PROP);
    const image = item.image || item.featured_image || '';
    const title = item.product_title || item.title || '';
    const price = item.final_line_price || item.line_price || 0;
    const quantity = getItemQuantity(item);
    const quantityMarkup =
      quantity > 1 ? ' <span class="review-product-quantity">× ' + quantity + '</span>' : '';

    return (
      '<div class="review-product-item customizer-cart-group__item">' +
      (image
        ? '<img src="' +
          escapeHtml(image) +
          '" alt="' +
          escapeHtml(title) +
          '" class="review-product-image" loading="lazy" width="80" height="80">'
        : '') +
      '<div class="review-product-details">' +
      '<h4 class="review-product-title">' +
      escapeHtml(title) +
      quantityMarkup +
      '</h4>' +
      renderVariantLine(item, type) +
      renderEngraving(item) +
      '</div>' +
      '<p class="review-product-price">' +
      formatMoney(price) +
      '</p>' +
      '</div>'
    );
  }

  function renderItemsList(items) {
    return items.map(renderLineItem).join('');
  }

  function renderGroup(group) {
    const componentCount = group.items.reduce(function (total, item) {
      return total + getItemQuantity(item);
    }, 0);
    const itemLabel = componentCount === 1 ? 'item' : 'items';

    let body = '';

    if (group.chains.length) {
      body +=
        '<h3 class="review-section-title">Your Custom Jewelry</h3>' +
        '<div class="review-products-list customizer-cart-group__list">' +
        renderItemsList(group.chains) +
        '</div>';
    }

    if (group.charms.length) {
      body +=
        '<h4 class="review-section-title customizer-cart-group__addons-title">Add Ons</h4>' +
        '<div class="review-products-list customizer-cart-group__list">' +
        renderItemsList(group.charms) +
        '</div>';
    }

    if (group.others.length) {
      body +=
        '<div class="review-products-list customizer-cart-group__list">' +
        renderItemsList(group.others) +
        '</div>';
    }

    body += renderFinalSaleAgreement(group.finalSaleAgreement);

    return (
      '<li class="rebuy-cart__flyout-item ' +
      GROUP_CLASS +
      '" data-pcp-group-id="' +
      escapeHtml(group.id) +
      '">' +
      '<div class="customizer-cart-group rebuy-customizer-cart-group">' +
      '<div class="customizer-cart-group__header">' +
      (group.design
        ? '<img src="' +
          escapeHtml(group.design) +
          '" alt="Custom jewelry design" class="customizer-cart-group__design-image" loading="lazy" width="120" height="120">'
        : '') +
      '<div class="customizer-cart-group__summary">' +
      '<p class="customizer-cart-group__title h6">' +
      escapeHtml(group.title) +
      '</p>' +
      '<p class="customizer-cart-group__subtitle text-subdued text-sm">Custom jewelry · ' +
      componentCount +
      ' ' +
      itemLabel +
      '</p>' +
      '<p class="customizer-cart-group__price">' +
      formatMoney(group.total) +
      '</p>' +
      '<div class="customizer-cart-group__actions">' +
      '<button type="button" class="link text-xs customizer-cart-group__edit" data-pcp-group-edit data-pcp-group-keys="' +
      escapeHtml(group.keys.join(',')) +
      '"' +
      (group.returnUrl
        ? ' data-pcp-group-return-url="' + escapeHtml(group.returnUrl) + '"'
        : '') +
      ' aria-label="Edit custom jewelry set">Edit</button>' +
      '<button type="button" class="link text-xs customizer-cart-group__remove" data-pcp-group-remove data-pcp-group-keys="' +
      escapeHtml(group.keys.join(',')) +
      '" aria-label="Remove custom jewelry set">Remove</button>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '<div class="customizer-cart-group__body">' +
      body +
      '</div>' +
      '</div>' +
      '</li>'
    );
  }

  function cleanupAllCustomizerGroups(container) {
    const scope = container || document;

    scope.querySelectorAll('.' + GROUP_CLASS).forEach(function (node) {
      node.remove();
    });

    scope.querySelectorAll('.' + HIDDEN_CLASS).forEach(function (node) {
      node.classList.remove(HIDDEN_CLASS);
    });

    if (!container) {
      lastAppliedHash = '';
    }
  }

  function buildElementFromHTML(html) {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = String(html || '').trim();
    return wrapper.firstElementChild;
  }

  function getGroupNode(container, groupId) {
    if (!container || !groupId) return null;
    const selector =
      '.' + GROUP_CLASS + '[data-pcp-group-id="' + CSS.escape(String(groupId)) + '"]';
    return container.querySelector(selector);
  }

  function animateGroupEnter(groupNode) {
    if (!groupNode) return;
    groupNode.classList.add('pcp-rebuy-group--enter');
    window.requestAnimationFrame(function () {
      groupNode.classList.add('pcp-rebuy-group--enter-active');
      window.setTimeout(function () {
        groupNode.classList.remove('pcp-rebuy-group--enter');
        groupNode.classList.remove('pcp-rebuy-group--enter-active');
      }, 220);
    });
  }

  function animateGroupExit(groupNode) {
    return new Promise(function (resolve) {
      if (!groupNode) return resolve();
      groupNode.classList.add('pcp-rebuy-group--exit');
      window.requestAnimationFrame(function () {
        groupNode.classList.add('pcp-rebuy-group--exit-active');
        window.setTimeout(function () {
          try {
            groupNode.remove();
          } catch (e) {}
          resolve();
        }, 220);
      });
    });
  }

  function isCartEmpty() {
    const cart = getRebuyCart();

    if (cart && typeof cart.item_count === 'number') {
      return cart.item_count === 0;
    }

    if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.itemCount === 'function') {
      return window.Rebuy.Cart.itemCount() === 0;
    }

    if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.hasItems === 'function') {
      return !window.Rebuy.Cart.hasItems();
    }

    return getCartItems().length === 0;
  }

  function handleCartUpdate(event) {
    if (event && event.type === 'rebuy:cart.add') {
      startEnrichmentWait();
      return;
    }

    if (event && event.type === 'rebuy:cart.enriched') {
      clearEnrichmentWait(true);
      return;
    }

    if (
      event &&
      (event.type === 'rebuy:smartcart.show' || event.type === 'rebuy:cart.change')
    ) {
      lastAppliedHash = '';
    }

    scheduleGrouping(false);
  }

  function scheduleGrouping(immediate) {
    if (awaitingEnrichment && !immediate) return;

    if (groupingTimer) window.clearTimeout(groupingTimer);
    groupingTimer = window.setTimeout(function () {
      groupingTimer = null;
      window.requestAnimationFrame(function () {
        if (isCartEmpty()) {
          cleanupAllCustomizerGroups();
          return;
        }
        applyGrouping(0);
      });
    }, immediate ? 0 : 30);
  }

  function getElementTitleAndVariant(el) {
    const titleEl = el.querySelector(TITLE_SELECTOR);
    const variantEl = el.querySelector(VARIANT_SELECTOR);
    return {
      title: titleEl ? titleEl.textContent.trim() : '',
      variant: variantEl ? variantEl.textContent.trim() : '',
    };
  }

  function mapItemsToElements(items, lineElements) {
    const map = {};
    const usedElements = {};

    items.forEach(function (item) {
      if (!item || !item.key) return;

      for (const keyedEl of lineElements) {
        if (usedElements[keyedEl]) continue;
        if (getLineItemKeyFromElement(keyedEl) === item.key) {
          map[item.key] = keyedEl;
          usedElements[keyedEl] = true;
          break;
        }
      }
    });

    if (Object.keys(map).length === items.length) return map;

    if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.getItemLineNumber === 'function') {
      items.forEach(function (item) {
        if (map[item.key]) return;

        const lineNumber = window.Rebuy.Cart.getItemLineNumber(item);
        if (!lineNumber) return;
        const el = lineElements[lineNumber - 1];
        if (el && !usedElements[el]) {
          map[item.key] = el;
          usedElements[el] = true;
        }
      });

      if (Object.keys(map).length === items.length) return map;
    }

    if (items.length === lineElements.length) {
      items.forEach(function (item, index) {
        if (!map[item.key]) {
          map[item.key] = lineElements[index];
        }
      });
      return map;
    }

    items.forEach(function (item) {
      if (map[item.key]) return;

      const groupId = getProp(item, GROUP_PROP);
      const instanceId = getProp(item, '_Customizer Instance');
      const itemTitle = (item.product_title || item.title || '').trim();
      const itemVariant =
        getProp(item, '_Variant Label') || String(item.variant_title || '').trim();

      const match = lineElements.find(function (el) {
        if (usedElements[el]) return false;

        if (instanceId && elementMatchesInstance(el, instanceId)) return true;

        if (groupId) {
          const normalizedGroupId = groupId.toLowerCase().replace(/[^a-z0-9]+/g, '-');
          if (String(el.className || '').toLowerCase().indexOf(normalizedGroupId) !== -1) return true;
        }

        const { title, variant } = getElementTitleAndVariant(el);
        return title === itemTitle && variant === itemVariant;
      });

      if (match) {
        map[item.key] = match;
        usedElements[match] = true;
      }
    });

    return map;
  }

  function applyGrouping(attempt) {
    if (isApplying) {
      groupingPending = true;
      return;
    }
    if (awaitingEnrichment && attempt === 0) return;
    attempt = attempt || 0;

    const container = getItemsContainer();
    if (!container) {
      retryGrouping(attempt, function () {
        applyGrouping(attempt + 1);
      });
      return;
    }

    const items = getCartItems();
    const groups = buildGroups(items);

    if (!groups.length) {
      lastAppliedHash = '';
      cleanupAllCustomizerGroups(container);
      lastGroupedKeys = new Set();
      return;
    }

    const hash = buildGroupHash(items, groups);
    let lineElements = getLineElements(container);
    if (!lineElements.length) {
      retryGrouping(attempt, function () {
        applyGrouping(attempt + 1);
      });
      return;
    }

    let elementMap = mapItemsToElements(items, lineElements);
    if (hash === lastAppliedHash && container.querySelector('.' + GROUP_CLASS)) {
      if (groupedItemsFullyHidden(groups, elementMap)) return;
      lastAppliedHash = '';
    }

    const expectedMapped = countGroupedItems(groups);
    if (countMappedItems(groups, elementMap) < expectedMapped) {
      retryGrouping(attempt, function () {
        applyGrouping(attempt + 1);
      });
      return;
    }

    isApplying = true;

    try {
      lineElements = getLineElements(container);
      elementMap = mapItemsToElements(items, lineElements);

      if (countMappedItems(groups, elementMap) < expectedMapped) {
        retryGrouping(attempt, function () {
          isApplying = false;
          applyGrouping(attempt + 1);
        });
        return;
      }

      const newGroupedKeys = new Set();
      const currentGroupIds = new Set();
      const insertedGroups = {};

      groups.forEach(function (group) {
        currentGroupIds.add(group.id);
        let anchor = null;

        group.items.forEach(function (item) {
          const el = elementMap[item.key];
          if (!el) return;
          if (!anchor) anchor = el;
          newGroupedKeys.add(item.key);
        });

        if (!anchor || insertedGroups[group.id]) return;

        const existing = getGroupNode(container, group.id);
        const nextMarkup = renderGroup(group);

        if (existing) {
          const nextNode = buildElementFromHTML(nextMarkup);
          const nextInner = nextNode ? nextNode.querySelector('.customizer-cart-group') : null;
          const existingInner = existing.querySelector('.customizer-cart-group');

          if (existing.parentNode && existing !== anchor.previousElementSibling) {
            anchor.parentNode.insertBefore(existing, anchor);
          }

          if (existingInner && nextInner) {
            existingInner.innerHTML = nextInner.innerHTML;
          } else if (nextNode) {
            existing.innerHTML = nextNode.innerHTML;
          }
        } else {
          anchor.insertAdjacentHTML('beforebegin', nextMarkup);
          const inserted = getGroupNode(container, group.id);
          animateGroupEnter(inserted);
        }

        insertedGroups[group.id] = true;
      });

      // Unhide items that are no longer part of any group, and hide current grouped items.
      lastGroupedKeys.forEach(function (key) {
        if (newGroupedKeys.has(key)) return;
        const el = elementMap[key];
        if (el) el.classList.remove(HIDDEN_CLASS);
      });

      newGroupedKeys.forEach(function (key) {
        const el = elementMap[key];
        if (el) el.classList.add(HIDDEN_CLASS);
      });

      // Remove group blocks that no longer exist.
      const staleGroups = Array.prototype.slice
        .call(container.querySelectorAll('.' + GROUP_CLASS))
        .filter(function (node) {
          const id = node.getAttribute('data-pcp-group-id') || '';
          return id && !currentGroupIds.has(id);
        });

      staleGroups.forEach(function (node) {
        animateGroupExit(node);
      });

      lastGroupedKeys = newGroupedKeys;

      if (groupedItemsFullyHidden(groups, elementMap)) {
        lastAppliedHash = hash;
      } else {
        retryGrouping(attempt, function () {
          applyGrouping(attempt + 1);
        });
      }
    } finally {
      isApplying = false;
      if (groupingPending) {
        groupingPending = false;
        scheduleGrouping(true);
      }
    }
  }

  function ensureObserver() {
    if (observer) return;

    observer = new MutationObserver(function () {
      if (groupingTimer || isApplying || awaitingEnrichment) return;
      if (isCartEmpty()) {
        cleanupAllCustomizerGroups();
        return;
      }
      scheduleGrouping();
    });

    const watch = function () {
      const container = getItemsContainer();
      if (!container) {
        window.setTimeout(watch, 100);
        return;
      }

      observer.observe(container, { childList: true, subtree: false });
    };

    watch();
  }

  function onRebuyReady() {
    ensureObserver();
    handleCartUpdate();
  }

  function bindEvents() {
    CART_EVENTS.forEach(function (eventName) {
      document.addEventListener(eventName, handleCartUpdate);
    });

    document.addEventListener('pcp:cart-items-added', startEnrichmentWait);
    document.addEventListener('rebuy:ready', onRebuyReady);

    if (window.Rebuy) {
      onRebuyReady();
    }
  }

  bindEvents();
})();
